<template>
  <v-menu
    bottom
    rounded
    offset-y
    nudge-bottom="6"
    transition="scale-transition"
    right
  >
    <template v-slot:activator="{ on }">
      <v-btn
        icon
        x-large
        v-on="on"
        class="ml-md-5"
      >
        <v-badge
          bordered
          bottom
          color="success"
          dot
          offset-x="40"
          offset-y="10"
        >
          <v-avatar
            color="blue"
            size="40"
          >
            <img
              src="@/assets/images/avatars/default-avatar.jpg"
              alt="profile Avatar"
            >
          </v-avatar>
        </v-badge>
      </v-btn>
    </template>
    <v-card>
      <v-list-item-content class="justify-center">
        <div class="px-3 text-center">
          <h5 v-if="form.person"> {{form.person.fullName}} </h5>
          <v-divider class="my-1"></v-divider>
          <v-btn
            text
            small
            block
            class="px-5"
            :to="{name: 'Profile'}"
          >
            {{ label.menu.editProfile }}
          </v-btn>
          <v-divider class="my-1"></v-divider>
          <v-btn
            text
            small
            block
            color="error"
            @click="logout"
          >
          <v-icon small class="mr-1">mdi-power</v-icon>
            {{ label.menu.logout }}
          </v-btn>
        </div>
      </v-list-item-content>
    </v-card>
  </v-menu>
</template>

<script>
import { mapGetters } from "vuex";
import label from "@/lang/StaticLabels.js";

export default {
  name: "TheAccountDropDown",
  data() {
    return{
      label,
    }
  },
  computed: {
    ...mapGetters({
      form: "identityX/profile",
    }),
  },
  methods: {
    logout() {
      this.$store.dispatch("logout");
    },
  },
  mounted() {
    this.$store.dispatch("identityX/getProfile");
  },
};
</script>
